(() => {
  const data = window.REGALA_REACTIONS;
  const t = window.regalaText;
  const section = document.getElementById('escuchar');
  if (!data?.items.length || !section) return;
  const items = data.items, video = document.getElementById('motherReaction');
  const clip = document.getElementById('reactionClip');
  const full = section.querySelector('.song-preview audio');
  const player = full.closest('[data-audio-player]');
  const toggle = section.querySelector('.reaction-play');
  const status = section.querySelector('.reaction-status');
  const thumbs = section.querySelector('.reaction-thumbnails');
  const view = section.querySelector('.reaction-viewer');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let index = 0, token = 0, playing = false, adjusting = false, readyOffset = 0, resumeAt = 0;
  const current = () => items[index];
  video.muted = true;
  video.dataset.mediaGroup = clip.dataset.mediaGroup = 'reaction-pair';
  function paint() {
    toggle.classList.toggle('is-playing', playing);
    toggle.querySelector('.reaction-play-icon').textContent = playing ? 'Ⅱ' : '▶';
    toggle.querySelector('.reaction-play-label').textContent = playing ? t('pause') : (video.ended ? t('rewatch') : t('watch'));
    toggle.setAttribute('aria-label', playing ? t('pauseReaction') : t('watchReaction'));
  }
  function stop() {
    token++; playing = false; video.pause(); clip.pause(); paint();
  }
  function alignVideo() {
    if (!playing || adjusting || !Number.isFinite(video.duration)) return;
    const elapsed = Math.max(0, clip.currentTime - readyOffset);
    if (elapsed >= video.duration - .08) { stop(); video.currentTime = video.duration; return; }
    if (Math.abs(video.currentTime - elapsed) > .25) {
      adjusting = true; video.currentTime = elapsed;
    }
    section.querySelector('.reaction-progress span').style.width = `${Math.min(100, elapsed / video.duration * 100)}%`;
  }
  video.addEventListener('seeked', () => { adjusting = false; });
  clip.addEventListener('timeupdate', alignVideo);
  clip.addEventListener('seeking', alignVideo);
  clip.addEventListener('waiting', () => { if (playing) video.pause(); });
  clip.addEventListener('playing', () => {
    if (!playing) return;
    const request = token; alignVideo();
    video.play().catch(error => { if (request === token && error.name !== 'AbortError') stop(); });
  });
  // The video is always muted, including the reference that has embedded music.
  video.addEventListener('volumechange', () => { if (!video.muted) video.muted = true; });
  video.addEventListener('ended', stop);
  clip.addEventListener('ended', stop);
  clip.addEventListener('pause', () => { if (playing) stop(); });
  full.addEventListener('play', stop);
  clip.addEventListener('loadedmetadata', () => {
    if (playing) clip.currentTime = readyOffset + resumeAt;
  });
  async function start() {
    if (!current().audio) {status.textContent = t('preparing');return;}
    stop(); const request = ++token;
    playing = true; readyOffset = current().chorusStart;
    status.textContent = t('loading');
    resumeAt = !video.ended && video.currentTime < video.duration - .15 ? video.currentTime : 0;
    if (!Number.isFinite(resumeAt)) resumeAt = 0;
    video.currentTime = resumeAt; clip.currentTime = readyOffset + resumeAt;
    paint();
    // Both play calls run in the click gesture (Safari/iOS requires this).
    const starts = [video.play().catch(error => { if (error.name !== 'AbortError') throw error; }), clip.play()];
    try {
      await Promise.all(starts);
      if (request !== token) return;
      status.textContent = ''; alignVideo();
      section.dispatchEvent(new CustomEvent('reaction-media-event', {bubbles:true,detail:{action:'play',reaction_id:current().reactionId,chorus_start:readyOffset}}));
    } catch (error) {
      if (request !== token) return;
      stop();
      if (error.name !== 'AbortError') status.textContent = t('playError');
    }
  }
  toggle.addEventListener('click', () => playing ? stop() : start());
  function select(next, moveThumb = true) {
    stop(); full.pause(); index = (next + items.length) % items.length;
    const item = current();
    video.src = item.video; video.poster = item.poster; video.load(); video.muted = true;
    video.setAttribute('aria-label', t('video', {name:item.tag}));
    clip.removeAttribute('src'); clip.load();
    if (item.audio) clip.src = item.audio;
    full.removeAttribute('src'); full.load();
    if (item.audio) full.src = item.audio;
    full.controls = false;
    player.dataset.audioPlayer = `reaction-${data.country}-${item.reactionId}`;
    player.dataset.duration = item.duration || 0;
    section.querySelector('.song-title').textContent = item.title;
    section.querySelector('.song-play').disabled = !item.audio;
    section.querySelector('.song-play').setAttribute('aria-label', `${t('listen')}: ${item.title}`);
    section.querySelector('.song-seek').setAttribute('aria-label', t('position', {name:item.title}));
    section.querySelector('.song-duration').textContent = item.duration ? `${Math.floor(item.duration/60)}:${String(Math.floor(item.duration%60)).padStart(2,'0')}` : '—';
    const [first, accent] = item.heading.split('|');
    const em = document.createElement('em'); em.className = 'brand-accent'; em.textContent = accent || '';
    document.getElementById('motherHeading').replaceChildren(document.createTextNode(first + ' '), em);
    document.getElementById('reactionEyebrow').textContent = item.example ? t('example') : t('songFor', {name:item.recipient});
    document.getElementById('reactionTag').textContent = item.tag;
    document.getElementById('reactionPosition').textContent = `${String(index+1).padStart(2,'0')} / ${items.length}`;
    status.textContent = item.audio ? '' : t('preparing');
    section.querySelector('.reaction-progress span').style.width = '0%';
    [...thumbs.children].forEach((button,i) => {button.setAttribute('aria-current',String(i === index));});
    if (moveThumb) {
      const thumb = thumbs.children[index];
      thumbs.scrollTo({left: thumb.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - thumb.clientWidth)/2, behavior: reduced.matches ? 'instant' : 'smooth'});
    }
    section.dataset.reactionId = item.reactionId;
    if (moveThumb) section.dispatchEvent(new CustomEvent('reaction-media-event', {bubbles:true,detail:{action:'change',reaction_id:item.reactionId}}));
    paint();
  }
  items.forEach((item, i) => {
    const button = document.createElement('button');
    button.type = 'button'; button.setAttribute('aria-label', `${i+1}. ${item.tag}: ${item.title}`);
    const img = document.createElement('img'); img.src = item.poster; img.alt = ''; img.loading = 'lazy'; img.width = 52; img.height = 64;
    button.append(img); button.addEventListener('click', () => select(i)); thumbs.append(button);
  });
  section.querySelector('.reaction-prev').addEventListener('click', () => select(index-1));
  section.querySelector('.reaction-next').addEventListener('click', () => select(index+1));
  view.tabIndex = 0;
  view.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault();select(index+(event.key === 'ArrowRight'?1:-1));}
  });
  let pointer = null, swiped = false;
  view.addEventListener('pointerdown', event => {if(event.target.closest('.reaction-side'))return;pointer={id:event.pointerId,x:event.clientX,y:event.clientY};});
  view.addEventListener('pointerup', event => {
    if(!pointer || pointer.id !== event.pointerId)return;
    const dx=event.clientX-pointer.x,dy=event.clientY-pointer.y;pointer=null;
    if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4){swiped=true;setTimeout(()=>{swiped=false;},0);select(index+(dx<0?1:-1));}
  });
  view.addEventListener('pointercancel',()=>{pointer=null;});
  view.addEventListener('click',event=>{if(swiped){event.preventDefault();event.stopImmediatePropagation();swiped=false;}},true);
  new IntersectionObserver(entries => {if(!entries[0].isIntersecting)stop();},{threshold:0}).observe(view);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();});
  window.addEventListener('pagehide',stop);
  select(0, false);
})();
